import { arbitrum, mainnet } from "wagmi/chains";

export const ORACLE_CONFIG = {
    [mainnet.id]: "0x7a5c5dba4fbd0e1e1a2ecdbe752fae55f6e842b3",
    [arbitrum.id]: "0xED38E9580e7c84629A0aC243F8d75f6fB5633B82",
};
